var angularModule = angular.module('t2g.common.services.RESTService', [
  'ngResource',
  require('t2g.common.services.userSessionService').name,
]);

module.exports = angularModule;

angularModule.factory('Customer', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/office/:officeId/customers';

  var resource = $resource(
    resourceUrl + '/:customerId/:subResource',
    { customerId: '@_id', officeId: '@customerAt' },
    {
      delete: { method: 'DELETE' },
      update: { method: 'PUT' },
      getOne: { method: 'GET', isArray: false },
      getAppointments: { method: 'GET', isArray: true, params: { subResource: 'appointments' } },
    },
  );

  return resource;
});

angularModule.factory('Object', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/office/:officeId/objects/:objectId/:action';

  var resource = $resource(
    resourceUrl,
    { objectId: '@_id', officeId: '@office' },
    {
      delete: { method: 'DELETE' },
      update: { method: 'PUT' },
      getOne: { method: 'GET', isArray: false },
      generateCalendarAddress: { method: 'GET', params: { action: 'generateCalendarAddress' } },
    },
  );

  return resource;
});

angularModule.factory('Appointment', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/v2/office/:officeId/appointment';

  var resource = $resource(
    resourceUrl + '/:appointmentId',
    { appointmentId: '@_id' },
    {
      save: { method: 'POST', isArray: true },
      update: { method: 'PUT', isArray: false },
    },
  );

  return resource;
});

angularModule.factory('Account', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/user/:action';

  var resource = $resource(
    resourceUrl,
    {},
    {
      changePassword: { method: 'POST', params: { action: 'changePassword' } },
      logout: { method: 'GET', params: { action: 'logout' } },
      ping: { method: 'GET', params: { action: 'ping' } },
    },
  );

  return resource;
});

angularModule.factory('Office', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/office/:officeId/:embeddedDocument';

  var resource = $resource(
    resourceUrl,
    {},
    {
      update: { method: 'PUT' },
      deleteImage: { method: 'DELETE' },
      removeLogo: { method: 'DELETE', url: settings.apiBase + '/api/v2/office/removeLogo' },
    },
  );

  return resource;
});

angularModule.factory('Industry', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/industry';

  var resource = $resource(resourceUrl, {}, {});

  return resource;
});

angularModule.factory('Booking', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/office/:officeId/booking/:bookingId/:action';

  var resource = $resource(
    resourceUrl,
    { bookingId: '@_id', officeId: '@officeId' },
    {
      accept: { method: 'POST', params: { action: 'accept' } },
      decline: { method: 'POST', params: { action: 'decline' } },
    },
  );

  return resource;
});



// WEBPACK FOOTER //
// ./src/app/common/services/RESTService.js